import {registerMerchant,merchantList,upMerchant,transferAccount,batchDelMerchant} from 'api/merchant';
import Cookies from 'js-cookie';

const merchant = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        registerMerchant({commit},params) {
            return new Promise((resolve, reject) => {
                registerMerchant(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        upMerchant({commit},params) {
            return new Promise((resolve, reject) => {
                upMerchant(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        merchantList({commit},params) {
            return new Promise((resolve, reject) => {
                merchantList(params.account, params.shopName, params.psize).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        transferAccount({commit},params) {
            return new Promise((resolve, reject) => {
                transferAccount(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchDelMerchant({commit},params) {
            return new Promise((resolve, reject) => {
                batchDelMerchant(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default merchant;



// WEBPACK FOOTER //
// ./src/store/modules/merchant.js